export default __webpack_public_path__ + "static/media/plasticRubber.7831c399.webp";